module.exports = __webpack_public_path__ + "img/austria-pneumonia-male.a27fd0f9.png";